export default __webpack_public_path__ + "static/media/stretch_v3_transparent.947a8d63.gif";